<ndt-phone-number-detail-link
  [phoneNumber]="extensionFax?.defaultPhoneNumber"
  [header]="'Default Phone Number'"
></ndt-phone-number-detail-link>
<ng-container>
  <h5>Email Address</h5>
  @for (emailAddress of formattedEmailAddress; track emailAddress) {
    <div class="extension-detail-item">
      <div class="break-word-detais-left-column">{{ emailAddress }}</div>
    </div>
  }
</ng-container>
